import classNames from 'classnames';
import { css } from 'css-literal-loader/styled';
import PropTypes from 'prop-types';
import React from 'react';

const styles = require('./FormCheck-styles.module.scss');

const propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  inline: PropTypes.bool.isRequired,
  large: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  inputRef: PropTypes.any,
  children: PropTypes.node,
  className: PropTypes.string,
};

const defaultProps = {
  inline: false,
  large: false,
  disabled: false,
  title: '',
  type: 'checkbox',
};

function FormCheck({
  inline,
  disabled,
  inputRef,
  className,
  title,
  children,
  type,
  invalid,
  large,
  center,
  ...props
}) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      title={title}
      className={classNames(
        className,
        styles.wrapper,
        inline && styles.inline,
        center && styles.center,
        large && styles.large,
        invalid && styles.invalid,
      )}
    >
      <input
        {...props}
        ref={inputRef}
        type={type}
        disabled={disabled}
        className={styles.input}
      />
      <span className={styles[type]} />
      {children}
    </label>
  );
}

FormCheck.propTypes = propTypes;
FormCheck.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => (
  <FormCheck inputRef={ref} {...props} />
));
